import NotificationBar from "components/notifications/NotificationBar";
import HttpService from "services/HttpService";
import {onShowMoviePageView} from 'shared/braze_events/events';
import PreferencesTracking from 'components/preferences/PreferencesTracking';

export default class PreferencesCta {

    INITIALIZED_CLASS = 'initialized';
    WRAPPER_ID = 'content_preference_wrapper';
    NOTIFY_ON_CLASS = 'notify_on';
    CTA_ELEMENT = '#contentPreferenceCta';
    CTA_ERROR_COPY = 'Oops! That didn\'t work. Please try again later.';
    CTA_ERROR_NOTIFICATIONS_DISABLED_COPY = 'Oops! That didn\'t work. Please enable site notifications and try again later.';
    NOTIFICATION_GRANTED = 'granted';
    WRAPPER_PARENT = '.cta-box';
    NOTIFICATION_NOT_SUPPORTED_CLASS = 'notification-ns';

    constructor() {
        this.container = null;
        this.cta = null;
        this._http = new HttpService();
        this._tracking = null;
        this.contentData = {};
        this.init();
    }

    init() {
        if (!this.browserIsNotificationCapable()) {
            this.massageCtaContainer();
            return false;
        }
        this.container = document.getElementById(this.WRAPPER_ID);
        if (!this.container) return false;
        this._notificationBar = new NotificationBar();
        this.cta = this.container.querySelector(this.CTA_ELEMENT);
        this.contentData = {...this.cta.dataset};
        this.contentData.notifyOn = this.contentData.notifyOn.toLowerCase() === 'true';
        this.container.classList.add(this.INITIALIZED_CLASS);
        this.cta.addEventListener('click', (event) => {
            event.preventDefault();
            this.ctaClick();
        });
        CBS.Promises.Tracking.onLoad(() => {
            this._tracking = new PreferencesTracking(this.contentData);
        });
        this.triggerPageView();
    }

    updateUi() {
        this.contentData.notifyOn
            ? this.cta.classList.add(this.NOTIFY_ON_CLASS)
            : this.cta.classList.remove(this.NOTIFY_ON_CLASS);
    }

    ctaClick() {
        if (this._notificationBar.isVisible()) return false;

        if (Notification.permission !== this.NOTIFICATION_GRANTED) {
            this.showToast(this.CTA_ERROR_NOTIFICATIONS_DISABLED_COPY, false);
            return false;
        }

        this.execXhrCall(this.contentData.notifyOn ? this.contentData['contentRemoveUrl'] : this.contentData['contentAddUrl'],
            this.contentData['contentTitle'])
            .then((resp) => {
                this.contentData.notifyOn = resp.data.success ? !this.contentData.notifyOn : this.contentData.notifyOn;
                this.updateUi();
                this.showToast(resp.data.message, resp.data.success);
                this._tracking.trackStateChangeAction(this.contentData.notifyOn);
            }).catch(() => {
            this.showToast(this.CTA_ERROR_COPY, false);
        });
    }

    execXhrCall(url, params) {
        return this._http.doGet(`${CBS.Registry.region.prefix}${url}?title=${params}`)
    }

    showToast(message, success) {
        this._notificationBar.showMessage(message, success);
        this._notificationBar.setAutoHide(3000);
    }

    triggerPageView() {
        onShowMoviePageView(this.contentData.contentType,
            {
                'triggerIAMNewContent': true,
                'notificationEnabled': Notification.permission === this.NOTIFICATION_GRANTED
            });
    }

    browserIsNotificationCapable() {
        return typeof Notification !== "undefined";
    }

    massageCtaContainer() {
        let breakElement = document.querySelector(this.WRAPPER_PARENT);
        if (typeof breakElement !== "undefined") breakElement.classList.add(this.NOTIFICATION_NOT_SUPPORTED_CLASS);
    }
    
}
